import { render, staticRenderFns } from "./follow_diagnostics.vue?vue&type=template&id=5aa039ad&scoped=true"
import script from "./follow_diagnostics.vue?vue&type=script&lang=js"
export * from "./follow_diagnostics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa039ad",
  null
  
)

export default component.exports